import r from "./Spinner.vue2.js";
import { openBlock as e, createElementBlock as n, createBlock as c, resolveDynamicComponent as p } from "vue";
import s from "../../_virtual/_plugin-vue_export-helper.js";
function t(o, l, i, a, m, f) {
  return e(), n("span", null, [
    (e(), c(p(o.spinner), {
      size: o.size,
      color: o.color
    }, null, 8, ["size", "color"]))
  ]);
}
const $ = /* @__PURE__ */ s(r, [["render", t]]);
export {
  $ as default
};
